import { NgModule } from '@angular/core';
import { BaseModule } from '@shared';
import { TierRoutingModule } from './tier-routing.module';
import { TierComponent } from './tier.component';
import {
  AddTierComponent,
  AlignTierComponent,
  SetKingRestaurantComponent,
  UnassignRestaurantComponent,
  UnlockTierComponent,
} from './components';
import { RemoveTierComponent } from './components/remove-tier/remove-tier.component';
import { SharedDataModule } from 'src/app/shared-data/shared-data.module';
@NgModule({
  declarations: [
    SetKingRestaurantComponent,
    UnassignRestaurantComponent,
    TierComponent,
    AddTierComponent,
    RemoveTierComponent,
    UnlockTierComponent,
    AlignTierComponent,
  ],
  imports: [BaseModule, SharedDataModule, TierRoutingModule],
  exports: [TierComponent],
})
export class TierModule {}
